<template>
  <Loader v-if="loading"></Loader>
  <div v-else>
    <Breadcrumb :items="items" />
    <noData v-if="noData" />
    <div class="form countryForm custom_card fadeIn" v-else>
      <div class="col-md-12">
        <div class="buttions">
          <button :class="{ active_bu: current_step == 'basic' }" @click="current_step = 'basic'">
            {{ $t("labels.vechileBase") }}
          </button>
          <button :class="{ active_bu: current_step == 'details' }" @click="current_step = 'details'">
            {{ $t("labels.vechilesDetails") }}
          </button>
        </div>
      </div>
      <ValidationObserver ref="formVehicles" @submit.prevent="submit" v-if="current_step == 'basic'">
        <div class="row">
          <validation-provider v-slot="{ errors }" :name="$t('labels.vehicleImage')" class="d-block my-auto"
            style="width: 100%" :rules="editMode ? '' : 'required'">
            <h5 class="text-center">
              {{ $t('labels.vehicleImage') }} 
            </h5>
            <!-- @change="sentImage($event)" -->
            <v-file-input :disabled="btnLoading" :loading="btnLoading" @change="uploadImage($event, 'vehicles', 'avatar')"
              v-model="data.avatar.mainMedia" class="d-none" :name="$t('labels.vehicleImage')" accept="image/*,|size:2048"
              label="" id="banner-create-image-main"></v-file-input>
            <label :class="errors[0] ? 'errors' : ''" for="banner-create-image-main"
              class="upload-image-label d-block d-flex justify-content-center align-items-center mx-auto text-center border rounded-xl overflow-hidden">
              <v-img v-if="data.avatar.preview" class="d-flex" cover :src="data.avatar.preview" :aspect-ratio="3.4" />
              <img v-else class="d-flex img-fluid mx-auto" src="@/assets/media/images/placeholder.png" />

              <span class="error--text d-block">
                {{ errors[0] }}
              </span>
            </label>
          </validation-provider>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.name') + $t('inArabic')" class="col-md-6"
            rules="required|min:3|max:250">
            <base-input @keypress="isArabic" :name="$t('labels.name') + $t('inArabic')" type="text"
              :placeholder="$t('labels.name') + $t('inArabic')" v-model="data.ar.name" />
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.name') + $t('inEnglish')" class="col-md-6"
            rules="required|min:2|max:250">
            <base-input @keypress="isEnglish" :name="$t('labels.name') + $t('inEnglish')" type="text"
              :placeholder="$t('labels.name') + $t('inEnglish')" v-model="data.en.name" />
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.description') + $t('inArabic')" class="col-md-6"
            rules="required|min:3|max:250">
            <base-input @keypress="isArabic" :name="$t('labels.description') + $t('inArabic')" type="text"
              :placeholder="$t('labels.description') + $t('inArabic')" v-model="data.ar.description" />
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.description') + $t('inEnglish')" class="col-md-6"
            rules="required|min:2|max:250">
            <base-input @keypress="isEnglish" :name="$t('labels.description') + $t('inEnglish')" type="text"
              :placeholder="$t('labels.description') + $t('inEnglish')" v-model="data.en.description" />
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <!-- Start model -->
          <ValidationProvider v-slot="{ errors }" :name="$t('labels.category')" class="col-md-6 col-lg-4"
            rules="required">
            <base-select-input :classes="errors[0] ? 'error' : ''" :loading="loadingPartner" v-model="data.category"
              :static="true" :staticItems="categories" :placeholder="$t('labels.category')"
              :name="$t('labels.category')"></base-select-input>

            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.vehicleType')" class="col-md-6 col-lg-4"
            rules="required">
            <base-select-input :classes="errors[0] ? 'error' : ''" :loading="loadingPartner" v-model="data.vehicle_type"
              :static="true" :staticItems="vehiclesType" :placeholder="$t('labels.vehicleType')"
              :name="$t('labels.vehicleType')"></base-select-input>

            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <!-- Start model -->
          <ValidationProvider v-slot="{ errors }" :name="$t('labels.brand')" class="col-md-6 col-lg-4" rules="required">
            <base-select-input :classes="errors[0] ? 'error' : ''" :loading="loadingBrand" v-model="data.brand"
              :static="true" :staticItems="brands" :placeholder="$t('labels.brand')"
              :name="$t('labels.brand')"></base-select-input>

            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <!-- Start model -->
          <!-- Start model -->
          <ValidationProvider v-slot="{ errors }" :name="$t('labels.model')" class="col-md-6 col-lg-4" rules="required">
            <base-select-input :classes="errors[0] ? 'error' : ''" :loading="loadingModel" v-model="data.brand_model"
              :static="true" :staticItems="brand_models" :placeholder="$t('labels.model')"
              :name="$t('labels.model')"></base-select-input>

            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.status')" class="col-md-4"
            rules="required|min:3|max:250">
            <!-- <base-input
              :name="$t('labels.status')"
              type="text"
              :placeholder="$t('labels.status')"
              v-model="data.status"
            /> -->
            <base-select-input :classes="errors[0] ? 'error' : ''" :loading="loadingBrand" v-model="data.status"
              :static="true" :staticItems="status" :placeholder="$t('labels.status')"
              :name="$t('labels.status')"></base-select-input>
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.is_active')" class="col-md-6 col-lg-4"
            rules="required">
            <div>
              <div class="input-title">
                <h4>{{ $t("active", { name: $t("labels.vehicle") }) }}</h4>
              </div>
              <v-checkbox :classes="errors[0] ? 'error' : ''" :name="$t('labels.is_active')" class="py-0 px-0"
                v-model="data.is_active" :label="$t('labels.is_active')"></v-checkbox>
            </div>
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <ValidationProvider :name="$t('labels.images')" class="col-md-12 col-lg-12">
            <div>
              <uplode-multiple v-if="data.images && data.images.length"
                @inputChanged="images_uploded($event, 'vehicles', 'image')" @imageDeleted="deleteImage"
                :data_src="data?.images" :Text="$t('labels.images')">
              </uplode-multiple>

              <uplode-multiple v-else @inputChanged="images_uploded($event, 'vehicles', 'image')"
                @imageDeleted="deleteImage" :Text="$t('labels.images')">
              </uplode-multiple>
            </div>
          </ValidationProvider>

          <validation-provider v-slot="{ errors }" :name="$t('labels.vehicleImage')" class="d-block my-auto"
            style="width: 100%" :rules="editMode ? '' : 'required'">
            <!-- @change="sentImage($event)" -->
            <h5 class="text-center">
              {{ $t('labels.videoImage') }}
            </h5>
            <v-file-input :disabled="btnLoading" :loading="btnLoading"
              @change="uploadImage($event, 'vehicles', 'avatar2')" v-model="data.avatar2.mainMedia" class="d-none"
              :name="$t('labels.vehicleImage')" accept="image/*,|size:2048" label=""
              id="banner-create-image-main2"></v-file-input>
            <label :class="errors[0] ? 'errors' : ''" for="banner-create-image-main2"
              class="upload-image-label d-block d-flex justify-content-center align-items-center mx-auto text-center border rounded-xl overflow-hidden">
              <v-img v-if="data.avatar2.preview" class="d-flex" cover :src="data.avatar2.preview" :aspect-ratio="3.4" />
              <img v-else class="d-flex img-fluid mx-auto" src="@/assets/media/images/placeholder.png" />

              <span class="error--text d-block">
                {{ errors[0] }}
              </span>
            </label>
          </validation-provider>

          <ValidationProvider :name="$t('labels.videos')" class="col-md-12 col-lg-12">
            <div>
              <uplode-multiple v-if="data?.videos && data?.videos?.length" :multiple="false"
                @inputChanged="images_uploded($event, 'vehicles', 'video')" @imageDeleted="deleteImage"
                :data_src="data?.videos" type="video/*" :Text="$t('labels.video')">
              </uplode-multiple>

              <uplode-multiple v-else @inputChanged="images_uploded($event, 'vehicles', 'video')"
                @imageDeleted="deleteImage" type="video/*" :Text="$t('labels.video')" :multiple="false">
              </uplode-multiple>
            </div>
          </ValidationProvider>
          <!-- Start :: is_active -->
        </div>
        <div class="button_wrapper center">
          <v-btn type="submit" @click="submit" :disabled="btnLoading" :loading="btnLoading">
            {{ $t("submit") }}
          </v-btn>
        </div>
        <!-- <base-button type="submit" @click="submit" class="center"></base-button> -->
      </ValidationObserver>

      <ValidationObserver ref="formVehicles" @submit.prevent="submit" v-if="current_step == 'details'">
        <div class="row">
          <h5>{{ $t("labels.details") }}</h5>
          <ValidationProvider v-slot="{ errors }" :name="$t('labels.details')" class="col-12" rules="required">
            <base-select-input :name="$t('labels.details')" v-model="data.details" :multiple="true" :static="true"
              :staticItems="details" :placeholder="$t('labels.details')"></base-select-input>
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <div v-for="detail in data.details" :key="detail.id" class="d-flex flex-wrap">
            <span class="col-md-12 text-center"> {{ detail.name }} : </span>
            <ValidationProvider v-slot="{ errors }" :name="$t('labels.name') + $t('inArabic')" class="col-md-6"
              rules="required|min:3|max:250">
              <base-input @keypress="isArabic" :name="$t('labels.name') + $t('inArabic')" type="text"
                :placeholder="$t('labels.name') + $t('inArabic')" v-model="detail.ar.name" />
              <span v-if="errors[0]" class="error--text d-inline-block">
                {{ errors[0] }}
              </span>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" :name="$t('labels.name') + $t('inEnglish')" class="col-md-6"
              rules="required|min:2|max:250">
              <base-input @keypress="isEnglish" :name="$t('labels.name') + $t('inEnglish')" type="text"
                :placeholder="$t('labels.name') + $t('inEnglish')" v-model="detail.en.name" />
              <span v-if="errors[0]" class="error--text d-inline-block">
                {{ errors[0] }}
              </span>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" :name="$t('labels.description') + $t('inArabic')" class="col-md-6">
              <base-input @keypress="isArabic" :name="$t('labels.description') + $t('inArabic')" type="text"
                :placeholder="$t('labels.description') + $t('inArabic')" v-model="detail.ar.description" />
              <span v-if="errors[0]" class="error--text d-inline-block">
                {{ errors[0] }}
              </span>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" :name="$t('labels.name') + $t('inEnglish')" class="col-md-6">
              <base-input @keypress="isEnglish" :name="$t('labels.description') + $t('inEnglish')" type="text"
                :placeholder="$t('labels.description') + $t('inEnglish')" v-model="detail.en.description" />
              <span v-if="errors[0]" class="error--text d-inline-block">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <h5>{{ $t("labels.specifications") }}</h5>

          <ValidationProvider v-slot="{ errors }" :name="$t('labels.specifications')" class="col-12" rules="required">
            <base-select-input :name="$t('labels.specifications')" v-model="data.specifications" :multiple="true"
              :static="true" :staticItems="specifications" :placeholder="$t('labels.specifications')"></base-select-input>
            <span v-if="errors[0]" class="error--text d-inline-block">
              {{ errors[0] }}
            </span>
          </ValidationProvider>

          <div v-for="detail in data.specifications" :key="detail.id" class="d-flex flex-wrap">
            <span class="col-md-12 text-center"> {{ detail.name }} : </span>
            <ValidationProvider v-slot="{ errors }" :name="$t('labels.name') + $t('inArabic')" class="col-md-6"
              rules="required|min:3|max:250">
              <base-input @keypress="isArabic" :name="$t('labels.name') + $t('inArabic')" type="text"
                :placeholder="$t('labels.name') + $t('inArabic')" v-model="detail.ar.name" />
              <span v-if="errors[0]" class="error--text d-inline-block">
                {{ errors[0] }}
              </span>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" :name="$t('labels.name') + $t('inEnglish')" class="col-md-6"
              rules="required|min:2|max:250">
              <base-input @keypress="isEnglish" :name="$t('labels.name') + $t('inEnglish')" type="text"
                :placeholder="$t('labels.name') + $t('inEnglish')" v-model="detail.en.name" />
              <span v-if="errors[0]" class="error--text d-inline-block">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="button_wrapper center">
          <v-btn type="submit" @click="updateDetails" :disabled="btnLoading" :loading="btnLoading">
            {{ $t("submit") }}
          </v-btn>
        </div>
        <!-- <base-button type="submit" @click="submit" class="center"></base-button> -->
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import BaseCountryFlagPhoneInput from "@/components/Forms/BaseCountryFlagPhoneInput.vue";

export default {
  components: { BaseCountryFlagPhoneInput },
  props: ["id"],

  data() {
    return {
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.vehicles.title"),
          disabled: false,
          href: "/vehicles/show-all",
        },
        {
          text: this.$t(`breadcrumb.vehicles.${this.id ? "edit" : "add"}`),
          disabled: true,
          href: "",
        },
      ],
      current_step: "basic",
      // Btn Loading
      loading: false,
      btnLoading: false,
      loadingPartner: false,
      loadingPackage: false,
      loadingModel: false,
      loadingBrand: false,
      status: [
        {
          id: 1,
          value: "ready_for_delivery",
          name: this.$t("labels.ready_for_delivery"),
        },
        {
          id: 2,
          value: "sold",
          name: this.$t("labels.sold"),
        },
      ],

      data: {
        avatar: {
          mainMedia: null,
          preview: null,
        },
        avatar2: {
          mainMedia: null,
          preview: null,
        },
        ar: {
          name: null,
          description: null,
        },
        en: {
          name: null,
          description: null,
        },
        category: null,
        vehicle_type: null,
        brand: null,
        brand_model: null,
        status: null,
        is_active: false,
        images: [],
        videos: [],
        details: [],
        specifications: [],
      },

      details: [],
      specifications: [],
      Addimages: [],
      Addvideos: [],
      noData: false,
      center: null,
      // Fixed Data
      vehiclesType: [],
      brands: [],
      categories: [],
      brand_models: [],
      statusList: [
        {
          id: "according",
          name: this.$t("according"),
        },
        {
          id: "not_according",
          name: this.$t("not_according"),
        },
      ],
    };
  },

  methods: {
    getBrandModels() {
      this.loadingPackage = true;
      this.axios({
        method: "GET",
        url: `brand_model_not_paginated`,
      })
        .then((res) => {
          this.brand_models = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.ar?.name ?? item.name,
            };
          });

          this.loadingPackage = false;
        })
        .catch((err) => {
          this.loadingPackage = false;
          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        });
    },
    getBrands() {
      this.loadingBrand = true;
      this.axios({
        method: "GET",
        url: `brand_not_paginated`,
      })
        .then((res) => {
          this.brands = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.ar.name,
            };
          });
          this.loadingBrand = false;
        })
        .catch((err) => {
          this.loadingBrand = false;

          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        })
        .finally(() => {
          this.loadingBrand = false;
        });
    },
    getVehicleType() {
      this.loadingBrand = true;
      this.axios({
        method: "GET",
        url: `vehicle_type_not_paginated`,
      })
        .then((res) => {
          this.vehiclesType = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.ar.name,
            };
          });
          this.loadingBrand = false;
        })
        .catch((err) => {
          this.loadingBrand = false;

          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        })
        .finally(() => {
          this.loadingBrand = false;
        });
    },
    getDetails() {
      // this.loadingBrand = true;
      this.axios({
        method: "GET",
        url: `detail_not_paginated`,
      })
        .then((res) => {
          this.details = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.ar.value,
              ar: {
                name: null,
                description: null,
              },
              en: {
                name: null,
                description: null,
              },
            };
          });
          // this.loadingBrand = false;
        })
        .catch((err) => {
          // this.loadingBrand = false;

          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        })
        .finally(() => {
          // this.loadingBrand = false;
        });
    },
    getSpecifications() {
      // this.loadingBrand = true;
      this.axios({
        method: "GET",
        url: `specification_not_paginated`,
      })
        .then((res) => {
          this.specifications = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.key,
              ar: {
                name: null,
              },
              en: {
                name: null,
              },
            };
          });
          // this.loadingBrand = false;
        })
        .catch((err) => {
          // this.loadingBrand = false;

          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        })
        .finally(() => {
          // this.loadingBrand = false;
        });
    },
    deleteImage(image) {
      if (image.id) {
        this.axios({
          method: "DELETE",
          url: `delete_image/${image.id}`,
        })
          .then(() => {
            this.$iziToast.success({
              title: this.$t("success"),
              message: this.$t("deletedSuccessfully"),
            });
          })
          .catch((err) => {
            this.$iziToast.error({
              title: this.$t("error"),
              message:
                err.response?.data.message ?? err.response?.data.messages,
            });
          });
      }
    },
    images_uploded(items, model, type) {
      this.btnLoading = true;
      const formData = new FormData();
      items.forEach((item, index) => {
        if (item.img_file) {
          formData.append(`files[${index}]`, item.img_file);
        }
      });
      formData.append("attachment_type", type);
      formData.append("model", model);
      this.axios({
        method: "POST",
        url: `attachments-multiple`,
        data: formData,
      })
        .then((res) => {
          if (type == "image") {
            this.Addimages = res.data.data;
          }
          if (type == "video") {
            this.Addvideos = res.data.data;
          }
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.btnLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnLoading = false;
        });
    },
    getCategories() {
      this.loadingPartner = true;
      this.axios({
        method: "GET",
        url: `category_not_paginated`,
      })
        .then((res) => {
          this.categories = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.ar.name,
            };
          });
          this.loadingPartner = false;
        })
        .catch((err) => {
          this.loadingPartner = false;

          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        })
        .finally(() => {
          this.loadingPartner = false;
        });
    },
    getVehicleRequirements() {
      this.axios({
        method: "GET",
        url: `vehicle-requirement_not_paginated`,
      })
        .then((res) => {
          this.data.vehicle_requirements = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item[this.$i18n.locale].title,
              status: null,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // Main Edit Data
    getEditData() {
      this.noData = false;
      this.loading = true;
      this.axios({
        method: "GET",
        url: `vehicle/${this.id}`,
      })
        .then((res) => {
          const result = res.data.data;
          this.data = {
            avatar: {
              mainMedia: null,
              preview: result.preview_image,
            },
            avatar2: {
              mainMedia: null,
              preview: `https://phpv8.aait-d.com/auto-boutique/public/storage/images/vehicles/${result?.videos[0]?.frameImage}`,
            },
            ar: result.ar,
            en: result.en,
            category: result.category,
            vehicle_type: result.vehivle_type,
            brand: result.brand,
            brand_model: result.brand_model,
            status: this.status.find((el) => {
              if (el.value == result.status) {
                return el;
              }
            }),
            is_active: result.is_active,
            images: result.images,
            videos: result?.videos,
            specifications: result.specifications.map((item) => {
              return {
                id: item.specification.id,
                name: item.specification.key,
                ar: item.ar,
                en: item.en,
              };
            }),
            details: result.details.map((item) => {
              return {
                id: item.detail.id,
                name: item.detail.ar.value,
                ar: item.ar,
                en: item.en,
              };
            }),
          };
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
          this.noData = true;
          this.loading = false;
        });
    },
    // Submit
    updateDetails() {
      this.$refs.formVehicles.validate().then((d) => {
        if (d) {
          this.btnLoading = true;

          // Create FormData
          const data = new FormData();
          this.data.specifications.map((el, index) => {
            data.append(`specifications[${index}][specification_id]`, el.id);
            data.append(`specifications[${index}][ar][name]`, el.ar.name);
            data.append(`specifications[${index}][en][name]`, el.en.name);
          });
          this.data.details.map((el, index) => {
            data.append(`details[${index}][detail_id]`, el.id);
            data.append(`details[${index}][ar][name]`, el.ar.name);
            data.append(`details[${index}][en][name]`, el.en.name);
            if (el.ar.description) {
              data.append(
                `details[${index}][ar][description]`,
                el.ar.description
              );
            }
            if (el.en.description) {
              data.append(
                `details[${index}][en][description]`,
                el.en.description
              );
            }
          });

          if (this.id) {
            // data.append("_method", "PUT");
          }
          let url = "";
          if (this.id) {
            url = `vehicle_details/${this.id}`;
          } else {
            url = "vehicle_details";
          }

          let message = this.id
            ? this.$t("editSuccess")
            : this.$t("addSuccess");
          this.axios({
            method: "POST",
            url: url,
            data: data,
          })
            .then(() => {
              this.$iziToast.success({
                title: this.$t("success"),
                message: message,
              });
              this.$router.push("/vehicles/show-all");
              this.btnLoading = false;
            })
            .catch((err) => {
              this.$iziToast.error({
                title: this.$t("error"),
                message: err.response.data.message,
              });
              this.btnLoading = false;
            });

          // =============== End:: Add ===============
        } else {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }
      });
    },
    // Submit
    submit() {
      this.$refs.formVehicles.validate().then((d) => {
        if (d) {
          this.btnLoading = true;

          // Create FormData
          const data = new FormData();

          if (this.data.avatar.mainMedia) {
            data.append("preview_image", this.data.avatar.mainMedia);
          }
          if (this.Addimages.length) {
            this.Addimages.map((el, index) => {
              data.append(`images[${index}]`, el);
            });
          }
          if (this.Addvideos.length) {
            this.Addvideos.map((el, index) => {
              data.append(`videos[${index}][video]`, el);
              // data.append(`videos[${index}][frame_image]`, el);
            });
          }
          if (this.data.avatar2.mainMedia) {
            data.append(`videos[0][frame_image]`, this.data.avatar2.mainMedia);
          }
          data.append("category_id", this.data.category.id);
          data.append("brand_id", this.data.brand.id);
          data.append("vehicle_type_id", this.data.vehicle_type.id);
          if (this.data.brand_model.id) {
            data.append("brand_model_id", this.data.brand_model.id);
          }
          data.append("ar[name]", this.data.ar.name);
          data.append("en[name]", this.data.en.name);
          data.append("ar[description]", this.data.ar.description);
          data.append("en[description]", this.data.en.description);
          data.append("status", this.data.status.value);
          data.append("is_active", +this.data.is_active);
          // data.append("is_in_order", +this.data.is_in_order);
          // this.data.vehicle_requirements.map((el, index) => {
          //   data.append(
          //     `vehicle_requirement_ids[${index}][requirement_id]`,
          //     el.id
          //   );
          //   data.append(`vehicle_requirement_ids[${index}][status]`, el.status);
          // });

          if (this.id) {
            data.append("_method", "PUT");
          }
          let url = "";
          if (this.id) {
            url = `vehicle/${this.id}`;
          } else {
            url = "vehicle";
          }

          let message = this.id
            ? this.$t("editSuccess")
            : this.$t("addSuccess");
          this.axios({
            method: "POST",
            url: url,
            data: data,
          })
            .then(() => {
              this.$iziToast.success({
                title: this.$t("success"),
                message: message,
              });
              this.$router.push("/vehicles/show-all");
              this.btnLoading = false;
            })
            .catch((err) => {
              this.$iziToast.error({
                title: this.$t("error"),
                message: err.response.data.message,
              });
              this.btnLoading = false;
            });

          // =============== End:: Add ===============
        } else {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }
      });
    },
    uploadImage(event, modal, varName) {
      if (event) {
        this.btnLoading = true;
        const data = new FormData();
        data.append("file", event);
        data.append("attachment_type", "image");
        data.append("model", modal);

        this.axios({
          method: "POST",
          url: "attachments",
          data: data,
        })
          .then((res) => {
            this.data[varName].mainMedia = res.data.data;
            this.data[varName].preview = URL.createObjectURL(event);
            let message = this.id
              ? this.$t("editSuccess")
              : this.$t("addSuccess");
            this.$iziToast.success({
              title: this.$t("success"),
              message: message,
            });
            this.btnLoading = false;
          })
          .catch((err) => {
            this.$iziToast.error({
              title: this.$t("validation.error"),
              message: err.response.data.message,
            });

            this.btnLoading = false;
          });
      }
    },
  },

  computed: {
    editMode() {
      return !!this.id;
    },
  },
  async created() {
    this.control = this.$permission.setControls(this.$route.path);
    this.getBrandModels();
    this.getBrands();
    this.getVehicleType();
    this.getCategories();
    this.getDetails();
    this.getSpecifications();
    // await this.getVehicleRequirements();
    if (this.editMode) {
      this.getEditData();
    }
  },
};
</script>

<style lang="scss">
.buttions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 10px;
  column-gap: 30px;
  width: 100% !important;

  button {
    display: inline-block;
    width: fit-content;
    border-radius: 8px;
    padding: 12px 20px;
    color: var(--main);
    border: 1px solid var(--main);
    font-weight: 500;
    font-size: 16px;
    transition: 0.4s all linear;

    &.active_bu {
      background: var(--main);
      color: #fff;
    }
  }
}

.v-input--radio-group--column {
  .v-input--radio-group__input {
    flex-direction: row !important;
  }
}

.v-input--selection-controls.v-input {
  margin-bottom: 0 !important;

  .v-messages {
    display: none !important;
  }
}

// .v-input--radio-group.v-input .v-input__control .v-input__slot {
//   padding-top: 0 !important;
// }
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 0;
}

.vehicle_requirement {
  margin-top: 10px;

  padding: 6px;

  .input-title {
    min-width: 200px;
    padding-top: 15px !important;

    h4 {
      margin: 0 !important;
    }
  }
}
</style>
